<template>
  <div class="container">
    <custom-select
      label="Actividad"
      :value="value"
      name="actividad-sujeto-obligado"
      @input="onChange"
      :items="actividades"
      :required="required"
      :analyticsTypology="config.analyticsTypology"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { actividadesSujetoObligado as actividades } from "@/config/constants/index.js";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "WorkActivitySujetoObligado",
  components: { CustomSelect },
  props: {
    value: String,
    required: {
      type: Boolean,
      default: false
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    actividades() {
      return actividades;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>
